"use strict";

module.exports = findIndex;
function findIndex(fn, list) {
  var i = 0;
  while (i < list.length) {
    if (fn(list[i])) return i;
    i++;
  }
  return -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/findIndex/findIndex.js
// module id = 519
// module chunks = 0